import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const api = () => process.env.REACT_APP_API_URL;
const base = () => `${api()}/api/v3/english-forms`;
const config = () => ({ headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } });

/** The English forms' links, for admins, and the SRTs they collect (rev6 Part 11). */
const EnglishFormService = {
    links: async () => (await axios.get(`${base()}/links`, config())).data,
    createLink: async (kind, coordinator) => (await axios.post(`${base()}/links`, { kind, coordinator }, config())).data,
    turnOff: async (id) => axios.delete(`${base()}/links/${id}`, config()),
    srts: async (q, page, size) => (await axios.get(`${base()}/srts`, { ...config(), params: { q, page, size } })).data,
    download: async (id) => (await axios.get(`${base()}/srts/${id}/download`, config())).data,
    remove: async (id) => axios.delete(`${base()}/srts/${id}`, config()),
    restore: async (id) => (await axios.post(`${base()}/srts/${id}/restore`, {}, config())).data,
};

/** The forms themselves, with no login. */
export const publicEnglishForm = (token) => {
    const url = `${api()}/api/v3/public/english-forms/${encodeURIComponent(token)}`;
    return {
        open: async () => (await axios.get(url)).data,
        request: async (body) => (await axios.post(`${url}/requests`, body)).data,
        // The file goes as the body, so nothing large is written to disk before it's refused
        srt: async (file, title, name) =>
            (
                await axios.post(`${url}/srts`, file, {
                    params: { title, name, fileName: file.name },
                    headers: { 'Content-Type': 'application/octet-stream' },
                })
            ).data,
    };
};

export default EnglishFormService;
